import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import BignumbersIndicadorConversao from "components/Bignumbers/BignumbersIndicadorConversao";
import componentStyles from "assets/theme/components/cards/dashboard/card-sales-value.js";

const useStyles = makeStyles(componentStyles);

export default function ResultsSummary({ results, isMobile, isMobile900 }) {
  const classes = useStyles();

  return (
    <>
      <Card
        classes={{
          root: classes.cardRoot,
        }}
      >
        <CardHeader
          subheader={
            <Grid
              container
              component={Box}
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs="auto">
                <Box
                  component={Typography}
                  variant="h2"
                  marginBottom="0!important"
                >
                  <Box component="span">Resumo dos Resultados</Box>
                </Box>
              </Grid>
            </Grid>
          }
          classes={{ root: classes.cardHeaderRoot }}
        ></CardHeader>
        <CardContent>
          <Grid container>
            <Grid item xs={isMobile ? 12 : (isMobile900 ? 6 : 4)}>
              <BignumbersIndicadorConversao
                periodoLabel="Dia [D-1]"
                resultadoAtual={results.DiaAtual}
                resultadoAnterior={results.DiaAnterior}
              />
            </Grid>
            <Grid item xs={isMobile ? 12 : (isMobile900 ? 6 : 4)}>
              <BignumbersIndicadorConversao
                periodoLabel="Semana"
                resultadoAtual={results.SemanaAtual}
                resultadoAnterior={results.SemanaAnterior}
              />
            </Grid>
            <Grid item xs={isMobile ? 12 : (isMobile900 ? 6 : 4)}>
              <BignumbersIndicadorConversao
                periodoLabel="Mês"
                resultadoAtual={results.MesAtual}
                resultadoAnterior={results.MesAnterior}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
